import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class SavefilterServices {
    public saveData: any = {};
    public savedFilterName: string;
}
